import { css } from '@emotion/core';
import styled from '@emotion/styled';
import MuiCancelIcon from '@material-ui/icons/Cancel';
import MuiCheckCircleIcon from '@material-ui/icons/CheckCircle';

import CustomSeatIcon from 'assets/icons/seat';
import { Title as CustomTitle } from 'components';
import { ICustomTheme } from 'interfaces';

export const cssAlignIcon = css({
  alignItems: 'center',
  display: 'flex',
});

export const cssDisabled = (theme: ICustomTheme) => ({
  color: theme.palette.grey[400],
  transition: theme.transitions.create('color'),
});

export const CancelIcon = styled(MuiCancelIcon)(
  ({ theme, disabled }: { theme: ICustomTheme; disabled: boolean }) => ({
    color: disabled ? theme.palette.grey[500] : theme.colors.error.main,
    fontSize: theme.typography.h3.fontSize,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1),
    },
  }),
);

export const CheckCircleIcon = styled(MuiCheckCircleIcon)(
  ({ theme, disabled }: { theme: ICustomTheme; disabled: boolean }) => ({
    color: disabled ? theme.palette.grey[500] : theme.colors.success.main,
    fontSize: theme.typography.h3.fontSize,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1),
    },
  }),
);

export const Container = styled.div<{
  theme: ICustomTheme;
  isCentered: boolean;
}>(({ theme, isCentered }) => ({
  alignItems: 'center',
  display: 'flex',
  height: theme.spacing(5),
  justifyContent: isCentered ? 'center' : 'left',
}));

export const SeatIcon = styled(CustomSeatIcon)<{ theme: ICustomTheme }>(
  ({ theme }) => ({
    fontSize: '4rem',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5rem',
      marginRight: theme.spacing(1),
    },
  }),
);

export const Title = styled(CustomTitle)(
  ({ isCentered }: { isCentered: boolean }) => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: isCentered ? 'center' : 'left',
    textTransform: 'unset',
  }),
);
